import React from 'react';
import PropTypes from 'prop-types';
import styled from 'fe-styled-components';
import { resetButton } from 'fe-appdir-lib-utils';
import { BouncingBars } from 'fe-comp-loader';
import theme from 'fe-appdir-lib-theme';

import { buttonCss } from '../style';

const PROP_TYPES = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['default', 'cta', 'standard', 'primary', 'ghost']),
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  isFetching: PropTypes.bool,
  disabled: PropTypes.bool,
  gaTrackId: PropTypes.string,
  gaTrackInfo: PropTypes.string,
};
const DEFAULT_PROPS = {
  type: 'default',
  size: 'md',
  isFetching: false,
  disabled: false,
};

const getLoaderSize = (size) => {
  const fontSize = size === 'sm' ? 14 : size === 'lg' ? 18 : 16;

  return fontSize * 1.5;
};

const getLoaderFill = (type) =>
  type === 'standard' ? theme.colorBase : theme.colorWhite;

const Button = styled.button`
  ${resetButton}
  ${(props) => buttonCss(props)};

  pointer-events: ${(props) => (props.isFetching ? 'none' : 'initial')};
  color: ${(props) =>
    props.isFetching ? 'transparent' : getLoaderFill(props.type)};
`;

/**
 * App <button> Button
 * @param {object} props
 * @return {reactElement}
 */
const AppButton = ({
  children,
  type,
  onClick,
  size,
  className,
  isFetching,
  disabled,
  gaTrackId,
  gaTrackInfo,
}) => (
  <Button
    type={type}
    onClick={onClick}
    size={size}
    className={className}
    isFetching={isFetching}
    disabled={disabled}
    data-ga-track-id={gaTrackId}
    data-ga-track-info={gaTrackInfo}
  >
    {isFetching ? (
      <BouncingBars size={getLoaderSize(size)} fill={getLoaderFill(type)} />
    ) : null}
    {children}
  </Button>
);

AppButton.propTypes = PROP_TYPES;
AppButton.defaultProps = DEFAULT_PROPS;

export default AppButton;
